import { StrictMode, useEffect, useState } from "react";
import { createRoot } from "react-dom/client";
import { EditorProvider, type EditorSession } from "@linempo/react-state";
import { createEditorComposition } from "./composition/editor.js";
import { Editor } from "./Editor.js";
import "./styles.css";

function App() {
  const [session, setSession] = useState<EditorSession | null>(null);
  const [error, setError] = useState<string | null>(null);
  useEffect(() => {
    // StrictMode replay gets a new composition; an abandoned setup never publishes its session.
    const editor = createEditorComposition();
    let active = true;
    setSession(null);
    setError(null);
    void editor.ready.then((next) => { if (active) setSession(next); }, (cause: unknown) => {
      if (active) setError(cause instanceof Error ? cause.message : String(cause));
    });
    return () => {
      active = false;
      void editor.dispose().catch((cause: unknown) => console.error("Editor cleanup failed", cause));
    };
  }, []);
  if (error) return <p className="boot-message" role="alert">编辑器初始化失败：{error}</p>;
  return session ? <EditorProvider session={session}><Editor /></EditorProvider> : <p className="boot-message">正在展开画纸…</p>;
}

const root = document.getElementById("root");
if (!root) throw new Error("Missing application root");
createRoot(root).render(<StrictMode><App /></StrictMode>);
